import axios from "axios";
import { apiList } from "./ApiList";
const AxiosInstance = axios.create({ baseURL: apiList.BaseUrlApi });
AxiosInstance.interceptors.request.use(
  function (config) {
    const insta = JSON.parse(localStorage.getItem("userInfo"));
    config.headers.token = insta?.token;
    config.headers.apikey = insta?.apikey;
    return config;
  },
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
);

export default AxiosInstance;
